<template>
  <div class="bg-back-2 p-[44px] rounded-[10px] mb-[32px] relative">
    <a-tag
      class="absolute top-[0px] left-[0px] p-[2px_8px]"
      style="border-radius: 8px 0px 8px 0px"
      :color="useDictItem('order_status', signalOrder.status)?.color"
    >
      <span class="text-14">{{
        useDictItem('order_status', signalOrder.status)?.label
      }}</span>
    </a-tag>
    <div class="grid grid-cols-2 gap-[36px]">
      <div
        v-for="(item, key) in orderInfo"
        :key="key"
        class="flex-y-center gap-[20px] justify-center"
      >
        <div class="text-font-60 w-[70px]">{{ item }}</div>
        <div class="w-[300px]">
          <span v-if="key === 'pay_fee'">
            {{ formatPrice(signalOrder[key], signalOrder.currency).string }}
          </span>
          <span v-else-if="key === 'price'">
            <template v-if="signalOrder?.order_type !== 2">
              {{
                formatPrice(
                  signalOrder?.pay_fee / signalOrder?.buy_num,
                  signalOrder?.currency
                ).string
              }}
            </template>
            <template v-else-if="signalOrder?.buy_num > 0">
              {{
                formatPrice(
                  signalOrder?.pay_fee /
                    (signalOrder?.rights?.total_storage / Math.pow(1024, 3)),
                  signalOrder?.currency
                ).string
              }}
            </template>
          </span>
          <span v-else-if="key === 'period'">
            <template
              v-if="signalOrder?.start_time && !signalOrder?.expired_time"
            >
              {{ $t('yong-jiu') }}
            </template>
            <template
              v-else-if="signalOrder?.start_time && signalOrder?.expired_time"
            >
              {{ timeFormat(signalOrder?.start_time, 'YYYY.MM.DD') }} ~
              {{ timeFormat(signalOrder?.expired_time, 'YYYY.MM.DD') }}
            </template>
          </span>
          <span v-else-if="key === 'buy_num'">
            {{
              signalOrder.order_type !== 2
                ? signalOrder[key]
                : signalOrder?.rights?.total_storage / Math.pow(1024, 3) + 'GB'
            }}
          </span>
          <span v-else> {{ signalOrder?.[key] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useTime } from '~/hooks/useTime'

const { $t } = useNuxtApp()

defineProps<{
  signalOrder: any
}>()

const { timeFormat } = useTime()

const orderInfo = {
  no: $t('ding-dan-hao'),
  rights_name: $t('shang-pin-xin-xi'),
  period: $t('you-xiao-qi'),
  buy_num: $t('shu-liang'),
  price: $t('dan-jia'),
  pay_fee: $t('shi-fu-kuan'),
}
</script>
